import Repository from "./repository"

export default {
    get() {
        return Repository.get("/api/s207-customer-changes/view")
    },
    post(params) {
        return Repository.post("/api/s207-customer-changes/edit", params)
    }
}